export const STATUS_VALIDATED = 'Validated';
export const STATUS_FAILED = 'Failed';
export const STATUS_CHECKING = 'Checking...';
export const STATUS_ICON_GREEN = { glyph: 'check', color: 'green' };
export const STATUS_ICON_RED = { glyph: 'close', color: 'red' };
export const NOT_AVAILABLE = 'N/A';
export const DSD_COOKIE_URL = '/api-tool-experience/v1/cookies';
export const COOKIE_URL = '/api/container/v1/cookies';
